// Action type
const SET_SELECTED_MERCHANTS = 'SET_SELECTED_MERCHANTS';

// Action creator
export const setSelectedMerchants = (
  selectedMerchants: (string | number)[]
) => ({
  type: SET_SELECTED_MERCHANTS,
  payload: selectedMerchants,
});

// Define and export the GeneralState type
export interface GeneralState {
  selectedMerchants: (string | number)[];
  // ...add other state properties here as needed
}

// Initial state
const initialState: GeneralState = {
  selectedMerchants: [],
  // ...other state
};

export default function general(state = initialState, action: any = {}) {
  switch (action.type) {
    case SET_SELECTED_MERCHANTS:
      return {
        ...state,
        selectedMerchants: action.payload,
      };
    // ...other cases
    default:
      return state;
  }
}
